import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import RootRouter from 'router/RootRouter'

function CsrRouter(props) {
    return (
        <Router>
            <RootRouter />
        </Router>
    )
}

export default CsrRouter
